import React, {Component} from 'react';
import LogoLady from "./LogoLady/LogoLady";
import {withStyles} from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Background from './LogoLady/flickeringScreen.gif';
import './App.css';

const styles = theme => ({
    root: {
        fontFamily: 'AllAges',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#000000',
        height: '100vh',
        width: '100vw'
    },
    center: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    logoWrapper: {
        maxHeight: '700px',
        backgroundImage: `url(${Background})`
    },
    subtitle: {
        marginTop: 0,
        fontSize: '1.8rem',
        '@media (min-width:600px)': {
            fontSize: '1.9rem',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '2.4rem',
        },
        textAlign: 'center',
        color: '#A0A0A0'
    }
});

class App extends Component {
    render() {
        const {classes} = this.props;
        return (
            <div className={classes.root}>
                <div className={classes.center}>
                    <LogoLady className={classes.logoWrapper}/>
                </div>
            </div>
        );
    }
}

export default withWidth()(withStyles(styles)(App));
